import { render, staticRenderFns } from "./RolePermissionsEdit.vue?vue&type=template&id=506ff54d&scoped=true&"
import script from "./RolePermissionsEdit.vue?vue&type=script&lang=ts&"
export * from "./RolePermissionsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./RolePermissionsEdit.vue?vue&type=style&index=0&id=506ff54d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ff54d",
  null
  
)

export default component.exports